export interface User {
  id?: string;
  created_at?: string;
  password?: string;
  username: string;
  authEmail: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string | null;
  userrole: string;
  isActive: boolean;
  productionLine?: string;
  requirePasswordUpdate: boolean;
  notifications?: string[];
}

export interface AdditionalUserData {
  username: string;
  first_name: string;
  last_name: string;
}

export interface AppMetaData {
  provider: string;
  providers: string[];
  userrole: string;
  useractive: boolean;
  productionLine?: string;
  claims_admin: boolean;
}

export interface UserDB {
  id?: string;
  created_at?: string;
  password?: string;
  username: string;
  auth_email: string;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string | null;
  raw_app_meta_data: AppMetaData;
  require_password_update: boolean;
  email_notifications?: string[];
}

export enum Userrole {
  Admin = "Admin",
  Techniker = "Techniker",
  Schichtleiter = "Schichtleiter",
  Mitarbeiter = "Mitarbeiter",
  Teamleiter = "Teamleiter",
  Produktionsleiter = "Produktionsleiter",
}

export interface raw_app_meta_data {
  provider: string;
  userrole: string;
  providers: string[];
  useractive: boolean;
  claims_admin: boolean;
  productionLine: string;
  password_reset_required: boolean;
}

export function transformUserForDatabase(user: User): UserDB {
  return {
    id: user.id,
    auth_email: user.authEmail,
    username: user.username,
    password: user.password,
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    phone: user.phone,
    raw_app_meta_data: {
      provider: "email",
      providers: ["email"],
      userrole: user.userrole,
      useractive: user.isActive,
      productionLine: user.productionLine || "",
      claims_admin: user.userrole === Userrole.Admin,
    },
    require_password_update: user.requirePasswordUpdate,
    email_notifications: user.notifications
  };
}

export function transformDatabaseObject(user: UserDB): User {
  return {
    id: user.id,
    username: user.username,
    authEmail: user.auth_email,
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email,
    phone: user.phone,
    userrole: user.raw_app_meta_data.userrole,
    isActive: user.raw_app_meta_data.useractive,
    productionLine: user.raw_app_meta_data.productionLine || "",
    requirePasswordUpdate: user.require_password_update,
    notifications: user.email_notifications
  };
}
